import React from 'react'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

interface AlwaysActiveTooltipProps {
  children: React.ReactNode
  content: React.ReactNode
  placement: string
  interactive?: boolean
  offset?: [number, number]
  enabled?: boolean
}

const AlwaysActiveTooltip = ({
  children,
  content,
  placement,
  interactive,
  offset,
  enabled
}: AlwaysActiveTooltipProps) => {
  const displayTheme = useDisplayTheme() as Theme
  return (
    <Tooltip
      mode={displayTheme}
      content={content}
      placement={placement}
      followCursor={false}
      interactive={interactive}
      offset={offset}
      enabled={enabled}>
      {/* This additional div ensures that the tooltip can still be triggered, even if the children have pointer-events set to none. */}
      <div>{children}</div>
    </Tooltip>
  )
}

export default AlwaysActiveTooltip
